export default {
  'Animate old photos': '动态老照片',
  'Animate faces in your photos with AI technology, create vivid videos.':
    '通过AI技术为照片里的人物面孔动态化，创建生动的视频。',
  'Upload a photo': '上传一张图片',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.':
    '注意：选择的照片中，人脸必须面向镜头，否则不能成功处理。',
  'Uploaded successfully!': '上传成功！',
  'Please select a template below': '请在下方选择一个模板',
  'Choose a GIF': '选择一个GIF',
  'Use this template': '选择这个',
  'Verify successfully! You will':
    '验证成功！不久你就会通过{{email}}收到视频！',
  'You will': '不久你就会通过{{email}}收到视频！',
  'What you should expect to happen next': '接下来会发生什么：',
  'We will process your photo into a dynamic video.':
    '我们会把你的图片处理成一个动态的视频。',
  'After processing, we will send the video to your email.':
    '处理结束后，我们会发送视频到你的邮箱。',
  'You can check the video in your email.': '你可以在邮箱查收视频。',
  'Your video will be delivered via email': '我们会通过邮件将视频发送给你',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.':
    '合成动态视频需要20-30分钟，请耐心等待。为了你的隐私安全，在处理结束后，你的图片会被自动删除。',
  'Your Email': '你的邮箱',
  'Last Name': '名字',
  'First Name': '姓氏',
  'Go back': '返回',
  'Invalid email address': '无效邮箱',
  'Enter verification code': '输入验证码',
  'Enter the verification code that we sent to':
    '输入我们发送给{{email}}的验证码。',
  Resend: '重新发送',
  'Verification code': '验证码',
  'Resend after': '{{num}}s后重新发送',
  'The verification code is invalid. You can request a new one.':
    '无效的验证码，你可以再次请求验证码。',
  'Synthesize Video': '合成视频',
  Next: '下一步',
  'Too many attempts, please try again later.': '请求频繁，请稍后再试。',
  'xx people is waitting in front of you to generate image.':
    ' creators ahead of you, please wait...',
  'Animating...': 'Animating...',
  'You are in line...': 'You are in line...',
  'Failed to generate, click to retry.': 'Failed to generate, click to retry.',
  'The processing will be completed soon, are you sure you want to cancel it?':
    'The processing will be completed soon, are you sure you want to cancel it?',
  freeAccountExceed: 'The image size cannot exceed 2MB in free version.',
  freeAccountHD: 'Upgrade to download HD watermark-free images.',
  UpgradeToDownloadAsGIF: 'Upgrade to download video as GIF.',
  UpgradeToUploadLimits: 'Upgrade to unlimited image uploads.',
  DynamicTitle: 'HitPaw Online Animate Old Photos',
  SizeLimit: 'No Image Size Limits',
  UploadLimit: 'Unlimited Image Uploads',
  DownloadNoWaterMark: 'Download HD Image with No Watermark',
  DownloadGIF: 'Download Video as GIF',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  priceWeek: '$3.99',
  priceMonth: '$1.99',
  priceYear: '$0.99',
  Week: 'Week',
  billMonth: '$7.99 Billed Monthly',
  billYear: '$47.99 Billed Annually',
};
